import { createWebHistory, createRouter } from 'vue-router'

const routes = [

];

const router = createRouter({
    history: createWebHistory(),
    routes,
});


router.onError((error) => {

    // Suppress no route match warning
    if (error.message && error.message.includes('No match found for location')) {
        // Suppress the specific "No match found" warning
        return;
    }
    console.error(error); // Log any other errors for debugging
});

export default router;
